import { render, staticRenderFns } from "./CurvedBottom.vue?vue&type=template&id=1ebd3b93"
import script from "./CurvedBottom.vue?vue&type=script&lang=js"
export * from "./CurvedBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports